import { configureCompat } from 'vue'

configureCompat({
  MODE: 3,
  COMPILER_INLINE_TEMPLATE: true,
  FILTERS: true,
  CONFIG_WHITESPACE: true,
  INSTANCE_SCOPED_SLOTS: true,
  INSTANCE_EVENT_EMITTER: true,
  OPTIONS_BEFORE_DESTROY: true,
  INSTANCE_LISTENERS: false, //this = true breaks Vue-Final-Modal close
  INSTANCE_EVENT_HOOKS: true,
  // ATTR_ENUMERATED_COERCION is deliberately NOT set, despite the console notice
  // asking for it. vue-instantsearch's SearchInput binds `:spellcheck="false"`,
  // which raises that deprecation at error level - "will likely lead to runtime
  // errors" - but nothing is actually wrong: under MODE: 3 compat is already off
  // for it, so Vue 3 semantics apply and the attribute renders "false", which is
  // what the library intends.
  //
  // Neither value it suggests helps. `false` changes nothing, because
  // isCompatEnabled already reads `value === true` under MODE 3, and the warning
  // only returns early for the literal "suppress-warning". That value does
  // silence it, but the runtime check is `val === true || val === "suppress-warning"`,
  // so it switches the Vue 2 coercion back on and ships `spellcheck="true"`.
  //
  // The warning is dev-only - warnDeprecation returns immediately in production -
  // so the noise never ships while the wrong attribute would. Verified both ways
  // in the browser.
});



/**
 * Toolkit JavaScript
 */
import { InitVue } from './vue-app.js';
import { load } from './modules/svgLoader.js';
import * as jsApps from './js-app.js';
import simpleUserApi from './utils/api/simpleUserApi.js';
import toolkitGlobal from './utils/toolkit-global.js';
import { InitPreact } from './preact-app.js';

//import the global cookie helper methods
//these are put directly on the window object
import "./modules/cookie.js"

//initalize js apps that don't depend on DOM Ready or personalization, only HTML parse complete
jsApps.initAllOnLoad();


//load and init sprite support
const spriteSheetURL = document.body.getAttribute("data-sprites");
if (spriteSheetURL) {
	load(spriteSheetURL);
}

//Development mode indication
if(import.meta.env.MODE === 'development'){
	console.warn("ADS Toolkit in development mode.");
}

//init apps and modules supporting Sitefinity personalization
if (window.personalizationManager) {
	window.personalizationManager.addPersonalizedContentLoaded(function () {	
    InitVue();
	InitPreact();
    jsApps.initAllAfterReady();
	});
}
else {
  InitVue();
  InitPreact();
	$(function () {
		jsApps.initAllAfterReady();
	});
}


//create a global indicating that the toolkit is loaded
//and fire a custom event that other's can listen to
//see /Content/js/toolkit-interface.js in Sitefinity for other side of this event
window.adsToolkitReady = true;
window.dispatchEvent(new CustomEvent('toolkitReady',{}));

//register the user API 
toolkitGlobal.register("userApi", simpleUserApi);

//max-width experiment
// import { init as initMaxWidthExperiment } from './experiments/max-width.js'
// initMaxWidthExperiment();

//theming experiment
// import { init as initThemingExperiment } from './experiments/theming.js';
// initThemingExperiment();


